import { Injectable, inject } from '@angular/core';
import DialogServices from '../services/dialog.service';
import BusinessRestServices from '../services/business-rest.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';

@Injectable({ providedIn: 'root' })
export default class BusinessService {
	private dialogServices: DialogServices = inject(DialogServices);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	showEmployerInvitationModal(user, successCallback?, errorCallback?) {
		if (!user.workerInvitation) {
			if (typeof successCallback === "function") successCallback();
			return;
		}
		var currentEmployer: any = user.parentBusinessUser || {};
		var invitingEmployer: any = user.workerInvitation.employer || {};
		if (!invitingEmployer.businessName) {
			if (typeof successCallback === "function") successCallback();
			return;
		}
		
		var invitationText: any = this.angularFilterHelperService.translate('Modal.Content.Employer_Invitation_Text').replace('%s', invitingEmployer.businessName) + ' ';
		var invitationQuestion: any = currentEmployer.businessName ?
		this.angularFilterHelperService.translate('Modal.Content.Employer_Invitation_Question_Company').replace('%s', currentEmployer.businessName).replace('%f', invitingEmployer.businessName) :
		this.angularFilterHelperService.translate('Modal.Content.Employer_Invitation_Question_Default');
		var invitationContent: any = invitationText + invitationQuestion;
		
		var dialog = this.dialogServices.confirmation({
			content: invitationContent,
			clickOutsideToClose: false,
			escapeToClose: false
		});
		dialog.afterClosed().subscribe(
			(data) => {
				if (data) {
					this.businessRestServices.acceptBusinessInvite({}, 
						() => {
							this.angularHelperService.getWindow().location.reload();
						});
					if (typeof successCallback === "function") successCallback();
				} else {
					this.businessRestServices.declineBusinessInvite({}, () => {
						console.log("Invitation declined");
					});
				}
			},
			() => {
				this.businessRestServices.declineBusinessInvite({}, () => {
					console.log("Invitation declined");
				});
				if (typeof errorCallback === "function") errorCallback();
			}
		);
	}
	
}